import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QtySelectComponentDef } from '@df/ui/form/qty-select.component.def';

@Component({
    selector: 'product-qty',
    templateUrl: 'product-qty.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductQtyComponent extends QtySelectComponentDef {}
